// extracted by mini-css-extract-plugin
export default {"audioPlayer":"audioplayer_audioPlayer__9VjE8"};